export const voiceCoilOptions = [
  {value: '0', label: 'Select One', disabled: true},
  {value: '1', label: 'Single Voice Coil'},
  {value: '2', label: 'Dual Voice Coil'},
]

export const getSpeakerCountOptions = (speakers) => {
  return [
    {value: '0', label: 'Select One', disabled: true},
    {value: '1', label: `1 ${speakers} `},
    {value: '2', label: `2 ${speakers}s`},
    {value: '3', label: `3 ${speakers}s`},
    {value: '4', label: `4  ${speakers}s`},
  ]
}

export const svcOhmOptions = [
  {value: '0', label: 'Select One', disabled: true},
  {value: '1', label: 'Single 2 Ω'},
  {value: '2', label: 'Single 4 Ω'},
  {value: '3', label: 'Single 8 Ω'},
]

export const dvcOhmOptions = [
  {value: '0', label: 'Select One', disabled: true},
  {value: '4', label: 'Dual 1 Ω'},
  {value: '5', label: 'Dual 2 Ω'},
  {value: '6', label: 'Dual 4 Ω'},
]

// use > find public | clip to generate this
export const imageSet = [
  '/Dual 1 Ohm Wiring Diagrams',
  '/Dual 1 Ohm Wiring Diagrams/(1) D1 Subwoofer',
  '/Dual 1 Ohm Wiring Diagrams/(1) D1 Subwoofer/Desktop',
  '/Dual 1 Ohm Wiring Diagrams/(1) D1 Subwoofer/Desktop/Wiring Diagram - (1) D1 - 0.5 Ohm - Desktop.jpg',
  '/Dual 1 Ohm Wiring Diagrams/(1) D1 Subwoofer/Desktop/Wiring Diagram - (1) D1 - 2 Ohm - Desktop.jpg',
  '/Dual 1 Ohm Wiring Diagrams/(1) D1 Subwoofer/Mobile',
  '/Dual 1 Ohm Wiring Diagrams/(1) D1 Subwoofer/Mobile/Wiring Diagram - (1) D1 - 0.5 Ohm - Mobile.jpg',
  '/Dual 1 Ohm Wiring Diagrams/(1) D1 Subwoofer/Mobile/Wiring Diagram - (1) D1 - 2 Ohm - Mobile.jpg',
  '/Dual 1 Ohm Wiring Diagrams/(2) D1 Subwoofers',
  '/Dual 1 Ohm Wiring Diagrams/(2) D1 Subwoofers/Desktop',
  '/Dual 1 Ohm Wiring Diagrams/(2) D1 Subwoofers/Desktop/Wiring Diagram - (2) D1 - 1 Ohm - Desktop.jpg',
  '/Dual 1 Ohm Wiring Diagrams/(2) D1 Subwoofers/Desktop/Wiring Diagram - (2) D1 - 4 Ohm - Desktop.jpg',
  '/Dual 1 Ohm Wiring Diagrams/(2) D1 Subwoofers/Mobile',
  '/Dual 1 Ohm Wiring Diagrams/(2) D1 Subwoofers/Mobile/Wiring Diagram - (2) D1 - 1 Ohm - Mobile.jpg',
  '/Dual 1 Ohm Wiring Diagrams/(2) D1 Subwoofers/Mobile/Wiring Diagram - (2) D1 - 4 Ohm - Mobile.jpg',
  '/Dual 1 Ohm Wiring Diagrams/(3) D1 Subwoofers',
  '/Dual 1 Ohm Wiring Diagrams/(3) D1 Subwoofers/Desktop',
  '/Dual 1 Ohm Wiring Diagrams/(3) D1 Subwoofers/Desktop/Wiring Diagram - (3) D1 - 0.67 Ohm - Desktop.jpg',
  '/Dual 1 Ohm Wiring Diagrams/(3) D1 Subwoofers/Desktop/Wiring Diagram - (3) D1 - 1.5 Ohm - Desktop.jpg',
  '/Dual 1 Ohm Wiring Diagrams/(3) D1 Subwoofers/Desktop/Wiring Diagram - (3) D1 - 6 Ohm - Desktop.jpg',
  '/Dual 1 Ohm Wiring Diagrams/(3) D1 Subwoofers/Mobile',
  '/Dual 1 Ohm Wiring Diagrams/(3) D1 Subwoofers/Mobile/Wiring Diagram - (3) D1 - 0.67 Ohm - Mobile.jpg',
  '/Dual 1 Ohm Wiring Diagrams/(3) D1 Subwoofers/Mobile/Wiring Diagram - (3) D1 - 1.5 Ohm - Mobile.jpg',
  '/Dual 1 Ohm Wiring Diagrams/(3) D1 Subwoofers/Mobile/Wiring Diagram - (3) D1 - 6 Ohm - Mobile.jpg',
  '/Dual 1 Ohm Wiring Diagrams/(4) D1 Subwoofers',
  '/Dual 1 Ohm Wiring Diagrams/(4) D1 Subwoofers/Desktop',
  '/Dual 1 Ohm Wiring Diagrams/(4) D1 Subwoofers/Desktop/Wiring Diagram - (4) D1 - 0.5 Ohm - Desktop.jpg',
  '/Dual 1 Ohm Wiring Diagrams/(4) D1 Subwoofers/Desktop/Wiring Diagram - (4) D1 - 2 Ohm - Desktop.jpg',
  '/Dual 1 Ohm Wiring Diagrams/(4) D1 Subwoofers/Desktop/Wiring Diagram - (4) D1 - 8 Ohm - Desktop.jpg',
  '/Dual 1 Ohm Wiring Diagrams/(4) D1 Subwoofers/Mobile',
  '/Dual 1 Ohm Wiring Diagrams/(4) D1 Subwoofers/Mobile/Wiring Diagram - (4) D1 - 0.5 Ohm - Mobile.jpg',
  '/Dual 1 Ohm Wiring Diagrams/(4) D1 Subwoofers/Mobile/Wiring Diagram - (4) D1 - 2 Ohm - Mobile.jpg',
  '/Dual 1 Ohm Wiring Diagrams/(4) D1 Subwoofers/Mobile/Wiring Diagram - (4) D1 - 8 Ohm - Mobile.jpg',
  '/Dual 2 Ohm Wiring Diagrams',
  '/Dual 2 Ohm Wiring Diagrams/(1) D2 Subwoofer',
  '/Dual 2 Ohm Wiring Diagrams/(1) D2 Subwoofer/Desktop',
  '/Dual 2 Ohm Wiring Diagrams/(1) D2 Subwoofer/Desktop/Wiring Diagram - (1) D2 - 1 Ohm - Desktop.jpg',
  '/Dual 2 Ohm Wiring Diagrams/(1) D2 Subwoofer/Desktop/Wiring Diagram - (1) D2 - 4 Ohm - Desktop.jpg',
  '/Dual 2 Ohm Wiring Diagrams/(1) D2 Subwoofer/Mobile',
  '/Dual 2 Ohm Wiring Diagrams/(1) D2 Subwoofer/Mobile/Wiring Diagram - (1) D2 - 1 Ohm - Mobile.jpg',
  '/Dual 2 Ohm Wiring Diagrams/(1) D2 Subwoofer/Mobile/Wiring Diagram - (1) D2 - 4 Ohm - Mobile.jpg',
  '/Dual 2 Ohm Wiring Diagrams/(2) D2 Subwoofers',
  '/Dual 2 Ohm Wiring Diagrams/(2) D2 Subwoofers/Desktop',
  '/Dual 2 Ohm Wiring Diagrams/(2) D2 Subwoofers/Desktop/Wiring Diagram - (2) D2 - 0.5 Ohm - Desktop.jpg',
  '/Dual 2 Ohm Wiring Diagrams/(2) D2 Subwoofers/Desktop/Wiring Diagram - (2) D2 - 2 Ohm - Desktop.jpg',
  '/Dual 2 Ohm Wiring Diagrams/(2) D2 Subwoofers/Desktop/Wiring Diagram - (2) D2 - 8 Ohm - Desktop.jpg',
  '/Dual 2 Ohm Wiring Diagrams/(2) D2 Subwoofers/Mobile',
  '/Dual 2 Ohm Wiring Diagrams/(2) D2 Subwoofers/Mobile/Wiring Diagram - (2) D2 - 0.5 Ohm - Mobile.jpg',
  '/Dual 2 Ohm Wiring Diagrams/(2) D2 Subwoofers/Mobile/Wiring Diagram - (2) D2 - 2 Ohm - Mobile.jpg',
  '/Dual 2 Ohm Wiring Diagrams/(2) D2 Subwoofers/Mobile/Wiring Diagram - (2) D2 - 8 Ohm - Mobile.jpg',
  '/Dual 2 Ohm Wiring Diagrams/(3) D2 Subwoofers',
  '/Dual 2 Ohm Wiring Diagrams/(3) D2 Subwoofers/Desktop',
  '/Dual 2 Ohm Wiring Diagrams/(3) D2 Subwoofers/Desktop/Wiring Diagram - (3) D2 - 1.34 Ohm - Desktop.jpg',
  '/Dual 2 Ohm Wiring Diagrams/(3) D2 Subwoofers/Desktop/Wiring Diagram - (3) D2 - 12 Ohm - Desktop.jpg',
  '/Dual 2 Ohm Wiring Diagrams/(3) D2 Subwoofers/Desktop/Wiring Diagram - (3) D2 - 3 Ohm - Desktop.jpg',
  '/Dual 2 Ohm Wiring Diagrams/(3) D2 Subwoofers/Mobile',
  '/Dual 2 Ohm Wiring Diagrams/(3) D2 Subwoofers/Mobile/Wiring Diagram - (3) D2 - 1.34 Ohm - Mobile.jpg',
  '/Dual 2 Ohm Wiring Diagrams/(3) D2 Subwoofers/Mobile/Wiring Diagram - (3) D2 - 12 Ohm - Mobile.jpg',
  '/Dual 2 Ohm Wiring Diagrams/(3) D2 Subwoofers/Mobile/Wiring Diagram - (3) D2 - 3 Ohm - Mobile.jpg',
  '/Dual 2 Ohm Wiring Diagrams/(4) D2 Subwoofers',
  '/Dual 2 Ohm Wiring Diagrams/(4) D2 Subwoofers/Desktop',
  '/Dual 2 Ohm Wiring Diagrams/(4) D2 Subwoofers/Desktop/Wiring Diagram - (4) D2 - 1 Ohm - Desktop.jpg',
  '/Dual 2 Ohm Wiring Diagrams/(4) D2 Subwoofers/Desktop/Wiring Diagram - (4) D2 - 4 Ohm - Desktop.jpg',
  '/Dual 2 Ohm Wiring Diagrams/(4) D2 Subwoofers/Mobile',
  '/Dual 2 Ohm Wiring Diagrams/(4) D2 Subwoofers/Mobile/Wiring Diagram - (4) D2 - 1 Ohm - Mobile.jpg',
  '/Dual 2 Ohm Wiring Diagrams/(4) D2 Subwoofers/Mobile/Wiring Diagram - (4) D2 - 4 Ohm - Mobile.jpg',
  '/Dual 4 Ohm Wiring Diagrams',
  '/Dual 4 Ohm Wiring Diagrams/(1) D4 Subwoofer',
  '/Dual 4 Ohm Wiring Diagrams/(1) D4 Subwoofer/Desktop',
  '/Dual 4 Ohm Wiring Diagrams/(1) D4 Subwoofer/Desktop/Wiring Diagram - (1) D4 - 2 Ohm - Desktop.jpg',
  '/Dual 4 Ohm Wiring Diagrams/(1) D4 Subwoofer/Desktop/Wiring Diagram - (1) D4 - 8 Ohm - Desktop.jpg',
  '/Dual 4 Ohm Wiring Diagrams/(1) D4 Subwoofer/Mobile',
  '/Dual 4 Ohm Wiring Diagrams/(1) D4 Subwoofer/Mobile/Wiring Diagram - (1) D4 - 2 Ohm - Mobile.jpg',
  '/Dual 4 Ohm Wiring Diagrams/(1) D4 Subwoofer/Mobile/Wiring Diagram - (1) D4 - 8 Ohm - Mobile.jpg',
  '/Dual 4 Ohm Wiring Diagrams/(2) D4 Subwoofers',
  '/Dual 4 Ohm Wiring Diagrams/(2) D4 Subwoofers/Desktop',
  '/Dual 4 Ohm Wiring Diagrams/(2) D4 Subwoofers/Desktop/Wiring Diagram - (2) D4 - 1 Ohm - Desktop.jpg',
  '/Dual 4 Ohm Wiring Diagrams/(2) D4 Subwoofers/Desktop/Wiring Diagram - (2) D4 - 4 Ohm - Desktop.jpg',
  '/Dual 4 Ohm Wiring Diagrams/(2) D4 Subwoofers/Mobile',
  '/Dual 4 Ohm Wiring Diagrams/(2) D4 Subwoofers/Mobile/Wiring Diagram - (2) D4 - 1 Ohm - Mobile.jpg',
  '/Dual 4 Ohm Wiring Diagrams/(2) D4 Subwoofers/Mobile/Wiring Diagram - (2) D4 - 4 Ohm - Mobile.jpg',
  '/Dual 4 Ohm Wiring Diagrams/(3) D4 Subwoofers',
  '/Dual 4 Ohm Wiring Diagrams/(3) D4 Subwoofers/Desktop',
  '/Dual 4 Ohm Wiring Diagrams/(3) D4 Subwoofers/Desktop/Wiring Diagram - (3) D4 - 2.67 Ohm - Desktop.jpg',
  '/Dual 4 Ohm Wiring Diagrams/(3) D4 Subwoofers/Desktop/Wiring Diagram - (3) D4 - 6 Ohm - Desktop.jpg',
  '/Dual 4 Ohm Wiring Diagrams/(3) D4 Subwoofers/Mobile',
  '/Dual 4 Ohm Wiring Diagrams/(3) D4 Subwoofers/Mobile/Wiring Diagram - (3) D4 - 2.67 Ohm - Mobile.jpg',
  '/Dual 4 Ohm Wiring Diagrams/(3) D4 Subwoofers/Mobile/Wiring Diagram - (3) D4 - 6 Ohm - Mobile.jpg',
  '/Dual 4 Ohm Wiring Diagrams/(4) D4 Subwoofers',
  '/Dual 4 Ohm Wiring Diagrams/(4) D4 Subwoofers/Desktop',
  '/Dual 4 Ohm Wiring Diagrams/(4) D4 Subwoofers/Desktop/Wiring Diagram - (4) D4 - 0.5 Ohm - Desktop.jpg',
  '/Dual 4 Ohm Wiring Diagrams/(4) D4 Subwoofers/Desktop/Wiring Diagram - (4) D4 - 2 Ohm - Desktop.jpg',
  '/Dual 4 Ohm Wiring Diagrams/(4) D4 Subwoofers/Desktop/Wiring Diagram - (4) D4 - 8 Ohm - Desktop.jpg',
  '/Dual 4 Ohm Wiring Diagrams/(4) D4 Subwoofers/Mobile',
  '/Dual 4 Ohm Wiring Diagrams/(4) D4 Subwoofers/Mobile/Wiring Diagram - (4) D4 - 0.5 Ohm - Mobile.jpg',
  '/Dual 4 Ohm Wiring Diagrams/(4) D4 Subwoofers/Mobile/Wiring Diagram - (4) D4 - 2 Ohm - Mobile.jpg',
  '/Dual 4 Ohm Wiring Diagrams/(4) D4 Subwoofers/Mobile/Wiring Diagram - (4) D4 - 8 Ohm - Mobile.jpg',
]
